import SpriteSymbol from "../../../node_modules/.pnpm/registry.npmmirror.com+svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/registry.npmmirror.com+svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-item-down-icon",
  "use": "icon-item-down-icon-usage",
  "viewBox": "0 0 12 8",
  "content": "<symbol viewBox=\"0 0 12 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-item-down-icon\">\n<g id=\"icon-item-down-icon_Frame 91\">\n<path id=\"icon-item-down-icon_Vector 1\" d=\"M1.125 1L5.68955 6.61791C5.84963 6.81493 6.15037 6.81493 6.31045 6.61791L10.875 1\" stroke=\"#B3B3B3\" stroke-width=\"2\" stroke-linecap=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol